import { inject, Injectable } from "@angular/core";
import mixpanel from 'mixpanel-browser';
import { LoginResp } from "../../models/Login";
import { EnvironmentService } from "../environment.service";

@Injectable({ providedIn: 'root' })
export class MixPanelAnalyticsService {

    environmentService = inject(EnvironmentService);
    constructor() {
        mixpanel.init(this.environmentService.env.mixPanelToken, {
            debug: !this.environmentService.env.production,
            track_pageview: false // We'll handle page views manually
        });
    }

    logPage(url: string) {
        this.logEvent('Page View', { url });
    }

    logEvent(eventName: string, params: any = {}) {
        mixpanel.track(eventName, params);
        //console.log('mixpanel event', eventName, params);
    }

    setUserProperties(sessionId: string, properties: LoginResp) {
        mixpanel.identify(sessionId);
        mixpanel.people.set({ $email: properties.UserDetails.LoginEmail });
        mixpanel.people.set({ $phone: properties.UserDetails.MobilePhone });
        mixpanel.people.set({ $name: `${properties.UserDetails.FirstName} ${properties.UserDetails.LastName}` });
        mixpanel.people.set(properties);
    }
}